export const BINDINGS = Object.freeze({
  throttleForward: 'KeyW',
  throttleReverse: 'KeyS',
  steerLeft: 'KeyA',
  steerRight: 'KeyD',
  boostMouseButton: 0,
  jumpMouseButton: 2,
  powerslide: 'ShiftLeft',
  powerslideAlternate: 'ShiftRight',
  airRollLeft: 'KeyQ',
  airRollRight: 'KeyE',
  ballCamera: 'Space',
  fpsCounter: 'F2',
  freeCamera: 'F3',
  playerScoreboard: 'Tab',
  pause: 'Escape',
});
